// apps/client/src/components/XeroSyncAssets.tsx

import React from 'react';
import { XeroSyncAssetsResponse, XeroSyncType } from '@avanzu/types';
import { XeroSyncButton } from './XeroSyncButton';

interface XeroSyncAssetsProps {
  onSyncComplete?: (result: XeroSyncAssetsResponse) => void;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  disabled?: boolean;
}

const XeroSyncAssets: React.FC<XeroSyncAssetsProps> = (props) => {
  return (
    <XeroSyncButton<XeroSyncAssetsResponse>
      syncType={XeroSyncType.ASSETS}
      pollInterval={250}
      {...props}
    />
  );
};

export default XeroSyncAssets;
